module.exports = __webpack_public_path__ + "img/portfolio-06-481x325.53251767.jpg";